import type { FaireBrandEntity } from "../../entity_types/brand";

export const b_y45d6be4by: FaireBrandEntity = {
  token: "b_y45d6be4by",
  type: "brand",
  name: "Mimosa",
  avatarUrl:
    "https://cdn.faire.com/fastly/a21546688686c646590a29881fea016d6e65dda82e5b81cf503b575d58785111.jpeg",
  bannerUrl:
    "https://cdn.faire.com/fastly/fd328a60c62114f7f94ff26d5c0431782dd961b4ac58e68710f50ac6300fe3b2.jpeg",
  logoUrl:
    "https://cdn.faire.com/fastly/a21546688686c646590a29881fea016d6e65dda82e5b81cf503b575d58785111.jpeg",
  heroImageUrl:
    "https://cdn.faire.com/fastly/fd328a60c62114f7f94ff26d5c0431782dd961b4ac58e68710f50ac6300fe3b2.jpeg",
  location: "Los Angeles, CA, USA",
  minimumOrderDollars: 100,
  rating: 4.8,
  reviewCount: 149,
  isTopShop: true,
  isInsider: true,
  description:
    "Welcome to MIMOSA, a beacon of Young Contemporary fashion, nestled in the vibrant heart of the Los Angeles area since 2021!\nOur name, inspired by the Spanish term \"MIMOSA,\" embodies the essence of affection, love, and the warmth of a heartfelt embrace, weaving these sentiments of care into each strand of our designs.\n\nAt MIMOSA, our mission is to create fashion that resonates with the essence of the modern woman —elegant and chic sophistication with cutting-edge style, all while upholding our commitment to quality. Each design is carefully curated from the finest fabrics, ensuring that our collections not only capture the essence of current trends but also stand the test of time.\n\nWhen you choose MIMOSA, you're not just wearing clothes; it's about embracing a narrative of love intricately woven into each thread and seam. It symbolizes a celebration of confidence, an homage to timeless beauty, and an embrace to the forefront of fashion trends, all enveloped in the nurturing warmth that inspired our brand's inception.",
  meta: {
    source: "api",
    importedAt: "2026-08-18T16:18:15.635Z",
    importedBy: "entity-db-cli",
  },
};
